import React from 'react';
import { Breadcrumbs } from '../Breadcrumbs';

export function PageHeader({
  header,
  subHeader,
  pages,
  headerAdornment,
  children,
}: {
  header: string | React.ReactNode;
  subHeader?: string | React.ReactNode;
  pages: { name: string; href: string; current: boolean }[];
  headerAdornment?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return (
    <div className='bg-white border-b border-gray-200 flex items-center justify-between px-10 py-4 sticky top-16 z-pageHeader'>
      <div>
        <div className='flex items-center gap-4'>
          <h1 className='text-gray-950 text-3xl font-bold leading-9 font-inter'>
            {header}
          </h1>
          {headerAdornment}
        </div>
        {subHeader && (
          <h2 className='text-gray-600 text-md leading-8 font-inter'>
            {subHeader}
          </h2>
        )}
        <Breadcrumbs pages={pages} />
      </div>
      {children && children}
    </div>
  );
}
